The high-level HTTP result of the webhook requests to retrieve.

See the `WebhookRequest.descriptionCode` documentation for a list of possible description codes.

If this is not provided then all requests will be returned regardless of their result.
